import React, { useState, forwardRef } from 'react';

const TutrialVideo = forwardRef(({ videoSrc, onVideoPlayed }, ref) => {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <div className="questionnaire-info-tutrial">
            <video
                ref={ref}
                className="questionnaire-info-tutrial__video"
                src={videoSrc}
                controls
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onEnded={() => {
                    setIsPlaying(false);
                    if (onVideoPlayed) onVideoPlayed();
                }}
            ></video>
            <div className={`questionnaire-info-tutrial__guide ${isPlaying ? "hide" : ""}`}>
                <img src="./images/videoplay-guide.svg" alt="" width="184" height="184"/>
            </div>
        </div>
    );
});

export default TutrialVideo;
